var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass:
              "h-14 px-6 sticky z-30 left-0 top-24 flex items-center justify-between bg-slate-300",
            style: { width: "calc(100vw - 0.5rem)" }
          },
          [
            _c(
              "div",
              [
                _c("BlTextBody2", {
                  attrs: { text: "Showing " + 1 + " appointment schedule(s)" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center gap-2" },
              [
                _c(
                  "div",
                  [
                    _c("BlSelectBox", {
                      attrs: { options: _vm.timeslotViewOptions, dense: "" },
                      on: {
                        change: function($event) {
                          return _vm.$emit("set-timeslot-view", $event)
                        }
                      },
                      model: {
                        value: _vm.timeslotView,
                        callback: function($$v) {
                          _vm.timeslotView = $$v
                        },
                        expression: "timeslotView"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("BlTextBody2", { attrs: { text: _vm.masterDate } })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "h-12 flex sticky z-20 top-38 bg-slate-200" },
          [
            _c("div", {
              staticClass:
                "h-12 w-20 sticky z-10 left-0 flex-shrink-0 bg-slate-200 border-b border-slate-400"
            }),
            _vm._v(" "),
            _vm._l(_vm.headers, function(n, idx) {
              return _c(
                "div",
                {
                  key: idx,
                  staticClass:
                    "h-12 py-1 px-2 flex-shrink-0 flex items-center justify-center border-b border-slate-400",
                  style: { width: "calc(" + _vm.slotWidth + ")" }
                },
                [
                  n.highlight
                    ? _c(
                        "div",
                        { staticClass: "h-7 flex items-center gap-1" },
                        [
                          _c("BlTextBody2", {
                            attrs: { text: n.label.split(" ")[0] }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "h-7 w-7 flex items-center justify-center rounded-full bg-light-purple-400"
                            },
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-pure-white",
                                attrs: { text: n.label.split(" ").pop() }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "h-7 truncate px-4",
                          attrs: { title: n.label }
                        },
                        [
                          _c("BlTextBody2", {
                            staticClass: "truncate",
                            attrs: { text: n.label }
                          })
                        ],
                        1
                      )
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-col relative bg-slate-200" },
          _vm._l(_vm.clockRound, function(time) {
            return _c(
              "div",
              {
                key: time,
                staticClass: "flex",
                attrs: { id: "recurring_time_view_" + time }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-20 py-2 px-3 flex-shrink-0 sticky z-10 left-0 bg-slate-200 flex justify-end border-b border-r border-slate-400 transition-all duration-300",
                    style: { height: _vm.slotHeight * 2 + "rem" }
                  },
                  [_c("BlTextBody2", { attrs: { text: time } })],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.headers, function(n, idx) {
                  return _c("div", {
                    key: idx,
                    staticClass:
                      "flex-shrink-0 flex flex-col gap-2 items-center justify-center border-b border-r border-slate-400 bg-slate-200 transition-all duration-300",
                    style: {
                      height: _vm.slotHeight * 2 + "rem",
                      width: "calc(" + _vm.slotWidth + ")"
                    }
                  })
                })
              ],
              2
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fixed z-50 right-6 bottom-6",
          style: { width: "31.25rem" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "h-14 px-6 flex items-center gap-4 rounded-t-3xl bg-light-purple-300 cursor-pointer",
              on: {
                click: function($event) {
                  _vm.chevronOpened = !_vm.chevronOpened
                }
              }
            },
            [
              _c("BlIcon", {
                staticClass: "w-5 h-5 transition-all duration-300",
                style: { rotate: !_vm.chevronOpened ? "180deg" : "" },
                attrs: { icon: "chevron-down", color: "secondary" }
              }),
              _vm._v(" "),
              !_vm.editTimeslotOpened
                ? _c("BlTextSubtitle2", {
                    staticClass: "text-pure-white",
                    attrs: { text: "Assign client to the selected timeslot" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.editTimeslotOpened
                ? _c("BlTextSubtitle2", {
                    staticClass: "text-pure-white",
                    attrs: { text: "Edit the timeslot" }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.chevronOpened
            ? _c(
                "div",
                {
                  staticClass: "bg-pure-white overflow-y-auto",
                  style: { maxHeight: "calc(100vh - 16rem)" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "py-4 px-6 flex flex-col gap-4 bg-pure-white border border-t-0 border-slate-400"
                    },
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "You're about to create an appointment with the following details:"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex items-center gap-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "w-25 flex-shrink-0 rounded shadow-md"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "h-7 flex items-center justify-center rounded-t bg-orange-200"
                              },
                              [
                                _c("BlTextBody2", {
                                  staticClass: "text-orange-700",
                                  attrs: {
                                    text: _vm.displayDate(
                                      _vm.currentSlot.date,
                                      "dddd"
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "h-18 flex flex-col items-center justify-center rounded-b bg-pure-white"
                              },
                              [
                                _c("BlTextTitle4", {
                                  staticClass: "text-orange-700",
                                  attrs: {
                                    text: _vm.displayDate(
                                      _vm.currentSlot.date,
                                      "DD"
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "text-orange-600",
                                  attrs: {
                                    text: _vm.displayDate(
                                      _vm.currentSlot.date,
                                      "MMMM"
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "py-3 px-3 flex flex-col gap-3" },
                          [
                            _c(
                              "div",
                              { staticClass: "flex flex-col gap-1" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "max-w-64 flex items-center gap-1",
                                    attrs: {
                                      title:
                                        _vm.therapistData.name || "Unselected"
                                    }
                                  },
                                  [
                                    _c("BlTextBody2", {
                                      attrs: { text: "Therapist:" }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextSubtitle3", {
                                      staticClass: "truncate",
                                      attrs: {
                                        text:
                                          _vm.therapistData.name || "Unselected"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("BlTextTitle4", {
                                  staticClass: "text-slate-800",
                                  attrs: {
                                    text:
                                      _vm.currentSlotTime.start_time_string +
                                      " - " +
                                      _vm.currentSlotTime.end_time_string
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex items-center gap-3" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "max-w-40 flex items-center gap-2"
                                  },
                                  [
                                    _vm.enableBranch &&
                                    _vm.currentSlot.room.branch
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "h-7 min-w-12 max-w-24 px-2 flex items-center justify-center rounded",
                                            style: {
                                              backgroundColor:
                                                _vm.currentSlot.room.branch
                                                  .background_color || "unset"
                                            },
                                            attrs: {
                                              title:
                                                _vm.currentSlot.room.branch.name
                                            }
                                          },
                                          [
                                            _c("BlTextBody2", {
                                              staticClass: "truncate",
                                              style: {
                                                color:
                                                  _vm.currentSlot.room.branch
                                                    .color || "unset"
                                              },
                                              attrs: {
                                                text:
                                                  _vm.currentSlot.room.branch
                                                    .name || "-"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "truncate",
                                        attrs: {
                                          title: _vm.currentSlot.room.name
                                        }
                                      },
                                      [
                                        _c("BlTextBody2", {
                                          staticClass: "truncate",
                                          attrs: {
                                            text: _vm.currentSlot.room.name
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "w-1 h-1 flex-shrink-0 bg-slate-600 rounded"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("BlTextBody2", {
                                      attrs: {
                                        text: _vm.creditsUsed + " credit(s)"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "Starts from " +
                                  _vm.displayDate(
                                    _vm.currentSlot.date,
                                    "DD MMM YYYY"
                                  )
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.editTimeslotOpened
                          ? _c(
                              "div",
                              { staticClass: "ml-auto h-36 flex items-center" },
                              [
                                _c("BlInputButton", {
                                  attrs: { type: "outlined", icon: "edit" },
                                  on: { clicked: _vm.openEditTimeslot }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.editTimeslotOpened
                        ? _c(
                            "div",
                            { staticClass: "grid grid-cols-4 gap-2" },
                            _vm._l(_vm.timeslotOptions, function(slot) {
                              return _c(
                                "div",
                                {
                                  key: slot.id,
                                  staticClass:
                                    "h-10 flex items-center justify-center flex-shrink-0 rounded border border-slate-400 transition-all duration-300",
                                  class: [
                                    _vm.timeInput.includes(
                                      slot.start_time_string
                                    )
                                      ? "bg-light-purple"
                                      : "bg-pure-white",
                                    slot.appointment_id
                                      ? "cursor-default bg-slate-200"
                                      : "cursor-pointer"
                                  ],
                                  attrs: {
                                    title: slot.appointment_id
                                      ? "Booked"
                                      : slot.start_time_string +
                                        " - " +
                                        slot.end_time_string
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onToggleTime(slot)
                                    }
                                  }
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass:
                                      "flex-shrink-0 transition-all duration-300",
                                    class: [
                                      _vm.timeInput.includes(
                                        slot.start_time_string
                                      )
                                        ? "text-pure-white"
                                        : "text-slate-1000",
                                      slot.appointment_id
                                        ? "text-slate-600"
                                        : ""
                                    ],
                                    attrs: {
                                      text:
                                        slot.start_time_string +
                                        " - " +
                                        slot.end_time_string
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.editTimeslotOpened
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "py-4 px-6 flex flex-col gap-4 bg-pure-white border border-t-0 border-slate-400"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-1" },
                            [
                              _vm.isOpenRoom
                                ? _c("BlTextSubtitle1", {
                                    attrs: {
                                      text: "Select a client and therapist"
                                    }
                                  })
                                : _c("BlTextSubtitle1", {
                                    attrs: { text: "Select a client" }
                                  }),
                              _vm._v(" "),
                              _vm.isOpenRoom
                                ? _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        "To book the open room, please fill out the information."
                                    }
                                  })
                                : _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        "Please select a client to assign to the therapist. In the next step, you can add subsequent schedules and then set the recurrence."
                                    }
                                  })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("BlSelectBox", {
                                attrs: {
                                  search: "",
                                  prefixIcon: "user-square",
                                  placeholder: "Select client",
                                  options: _vm.clientOptions,
                                  drop: "up",
                                  searching: _vm.clientLoading
                                },
                                on: {
                                  change: _vm.onChangeClient,
                                  search: _vm.fetchClients
                                },
                                model: {
                                  value: _vm.clientInput,
                                  callback: function($$v) {
                                    _vm.clientInput = $$v
                                  },
                                  expression: "clientInput"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isOpenRoom
                            ? _c(
                                "div",
                                [
                                  _c("BlSelectBox", {
                                    key:
                                      "select-therapist-" +
                                      _vm.clientInput +
                                      "-date=" +
                                      _vm.currentSlot.date +
                                      "&start_time=" +
                                      _vm.currentSlotTime.start_time_string +
                                      "&end_time=" +
                                      _vm.currentSlotTime.end_time_string +
                                      "&room_id=" +
                                      _vm.currentSlot.room.id,
                                    attrs: {
                                      search: "",
                                      prefixIcon: "user",
                                      placeholder: _vm.clientInput
                                        ? "Select therapist"
                                        : "Choose the client first to enable therapist selection.",
                                      options: _vm.therapistOptions,
                                      disabled: !_vm.clientInput,
                                      searching: _vm.therapistLoading
                                    },
                                    on: {
                                      change: _vm.onChangeTherapist,
                                      search: _vm.fetchTherapists
                                    },
                                    model: {
                                      value: _vm.therapistInput,
                                      callback: function($$v) {
                                        _vm.therapistInput = $$v
                                      },
                                      expression: "therapistInput"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editTimeslotOpened &&
                  _vm.clientInput &&
                  _vm.therapistInput
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "py-4 px-6 flex flex-col gap-4 bg-pure-white border border-t-0 border-slate-400"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-1" },
                            [
                              _c("BlTextSubtitle1", {
                                attrs: {
                                  text: "Select credits for this appointment"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "Select the source of credits to apply for this appointment."
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-2" },
                            [
                              _c("BlSelectBox", {
                                key:
                                  "select-package-item-" +
                                  _vm.clientInput +
                                  "-" +
                                  _vm.therapistInput +
                                  "-" +
                                  _vm.timeInput.length,
                                attrs: {
                                  search: "",
                                  prefixIcon: "piggy",
                                  placeholder: _vm.creditLoading
                                    ? "Loading ..."
                                    : "Select item",
                                  options: _vm.packageItemOptions,
                                  disabled:
                                    !_vm.clientInput || !_vm.therapistInput,
                                  drop: "up"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.packageItemIdInput = $event
                                  }
                                },
                                model: {
                                  value: _vm.packageItemIdInput,
                                  callback: function($$v) {
                                    _vm.packageItemIdInput = $$v
                                  },
                                  expression: "packageItemIdInput"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.packageItemIdInput
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "py-2 px-3 flex items-center justify-between gap-2 bg-cornflower-200 rounded"
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: {
                                      text:
                                        "Remaining credits available for this item"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "h-5.5 w-11 flex items-center justify-center bg-cornflower-800 rounded"
                                    },
                                    [
                                      _c("BlTextSubtitle3", {
                                        staticClass: "text-cornflower-200",
                                        attrs: { text: _vm.remainingCredits }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editTimeslotOpened
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "py-4 px-6 flex flex-col gap-4 bg-pure-white border border-t-0 border-slate-400"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-1" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center mb-2 cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      _vm.setAssignSupervisorsInput = !_vm.setAssignSupervisorsInput
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pl-2 pr-4",
                                      style: { transform: "scale(1.375)" }
                                    },
                                    [
                                      _c("BlInputToggle", {
                                        attrs: {
                                          checked: _vm.setAssignSupervisorsInput
                                        },
                                        on: {
                                          changed: function($event) {
                                            _vm.setAssignSupervisorsInput = !_vm.setAssignSupervisorsInput
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle1", {
                                    attrs: { text: "Assign supervisor" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "If you assign a supervisor, they will be able to view this appointment on their Sessions page without affecting their appointments and availability slots."
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.setAssignSupervisorsInput
                            ? _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _c("BlSearchBox", {
                                    key:
                                      "select-assign-supervisors-" +
                                      _vm.clientInput +
                                      "-" +
                                      _vm.therapistInput,
                                    attrs: {
                                      type: "user",
                                      placeholder: "Select therapist",
                                      options: _vm.assignSupervisorOptions,
                                      searching: _vm.assignSupervisorsLoading,
                                      drop: "up"
                                    },
                                    on: {
                                      search: _vm.fetchSupervisors,
                                      change: function($event) {
                                        _vm.assignSupervisorsInput = $event
                                      }
                                    },
                                    model: {
                                      value: _vm.assignSupervisorsInput,
                                      callback: function($$v) {
                                        _vm.assignSupervisorsInput = $$v
                                      },
                                      expression: "assignSupervisorsInput"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.editTimeslotOpened
            ? _c(
                "div",
                {
                  staticClass:
                    "h-18 px-6 flex items-center gap-4 border border-t-0 border-slate-400 rounded-b-3xl bg-pure-white"
                },
                [
                  _c("BlInputButton", {
                    staticClass: "w-full",
                    attrs: {
                      label: "Continue to recurrence setting",
                      disabled: _vm.isDisabledSubmit,
                      loading: _vm.submitLoading
                    },
                    on: { clicked: _vm.onSubmit }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.editTimeslotOpened
            ? _c(
                "div",
                {
                  staticClass:
                    "h-18 px-6 grid grid-cols-2 items-center gap-4 border border-t-0 border-slate-400 rounded-b-3xl bg-pure-white"
                },
                [
                  _c("BlInputButton", {
                    attrs: { type: "plain", label: "Cancel" },
                    on: { clicked: _vm.onCancelEditTimeslot }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: { label: "Update", disabled: !_vm.timeInput.length },
                    on: { clicked: _vm.onUpdateTimeslot }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("SlotRecurring", {
        attrs: {
          isCompact: _vm.timeslotView === "compact",
          isOpenRoom: _vm.isOpenRoom,
          period: _vm.currentSlotTime,
          therapist: {
            id: _vm.therapistData.id,
            name: _vm.therapistData.name || "No therapist selected"
          },
          room: _vm.currentSlot.room,
          position: _vm.currentSlotPosition,
          assets: _vm.currentSlotAssets
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.existingAppointments, function(slot, idx) {
        return _c("SlotRecurring", {
          key: idx + "_" + slot.id,
          style: { zIndex: 1 },
          attrs: {
            isCompact: _vm.timeslotView === "compact",
            period: slot.period,
            therapist: slot.user,
            room: slot.room,
            position: slot.position,
            assets: slot.assets
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3421ce0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3421ce0c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/overlay/SelectClientRecurring.vue
// module id = null
// module chunks = 